import { ABU, Md, Style } from "@client";
import { css } from "@emotion/css";
import { Modal } from "antd";
import React, { useState } from "react";

export function IntroContent({
  msg,
  visible,
  onOk,
  title,
  withSearchTips,
}: {
  msg: string | React.ReactNode[];
  visible: boolean;
  onOk: () => void;
  title: string;
  withSearchTips: boolean;
}) {
  const _items = typeof msg === "string" ? msg.trim().split("\n") : msg,
    items: React.ReactNode[] = [
      ..._items,
      withSearchTips ? (
        <p>
          {_items.length + 1}
          .&nbsp;每次搜寻都请仔细对待，记下搜索到的结果，再次搜索仍可能产生搜寻成本。
        </p>
      ) : null,
    ].filter((s) => s);
  const [itemIndex, setItemIndex] = useState(0),
    over = itemIndex >= items.length - 1;
  return (
    <Modal
      {...Md.pageProps}
      visible={visible}
      title={title}
      cancelButtonProps={{ hidden: !over || items.length <= 1, className: Style.btnWarningSm }}
      cancelText="再读一遍"
      onCancel={() => setItemIndex(0)}
      okText={over ? "完成阅读" : "下一条"}
      onOk={() => (over ? onOk() : setItemIndex(itemIndex + 1))}
    >
      <ul
        className={css`
          max-height: 70vh;
          overflow: auto;
        `}
      >
        {items.slice(0, itemIndex + 1).map((item, i) => (
          <li
            className={css`
              margin-top: 0.5rem;
              animation: antFadeIn 1s;
              font-size: 1.5rem;
            `}
            key={i}
          >
            {item}
          </li>
        ))}
      </ul>
    </Modal>
  );
}

export function NormalDist() {
  return (
    <a
      onClick={() =>
        Modal.info({
          ...Md.fnProps,
          title: "正态分布",
          content: (
            <div
              className={css`
                img {
                  max-width: 100%;
                  max-height: 20rem;
                  margin: 1rem auto;
                }
              `}
            >
              <p>
                又名高斯分布（英语：Gaussian
                distribution）、正规分布，是一个非常常见的连续概率分布。正态分布在统计学上十分重要，经常用在自然和社会科学来代表一个不明的随机变量。
              </p>
              <img src={`${ABU}scene/intro/normalDist.png`} />
              <img src={`${ABU}scene/intro/normalDist02.jpg`} />
            </div>
          ),
        })
      }
    >
      &nbsp;正态分布&nbsp;
    </a>
  );
}
